import React from 'react';

import { useAppDispatch, useAppSelector } from '@pkg/hooks';

import { setNFTManagerSearchValue, updateNFTManagerFilters } from '@app/store/actions/nft-manager';
import { useWalletStore } from '@app/store/zustand';

import { FiltersListAccordion } from '../../components/Filters/Filters';
import { getFiltersCount } from '../utils';

import { useGetNfts } from './useGetNfts';

export const useManagerFilterProps = () => {
    const { data } = useGetNfts();
    const dispatch = useAppDispatch();

    const onClearFilters = () => {
        dispatch(updateNFTManagerFilters({ clear: true }));
    };

    const total = data?.pages?.[0].paging.total || 0;

    const syncedWallets = useWalletStore((state) => state.connectedWallets.map((item) => item.address));
    const managerSearchValue = useAppSelector((state) => state.nftManager.managerSearchValue);
    const managerFilters = useAppSelector((state) => state.nftManager.managerFilters);
    const filtersCount = getFiltersCount(managerFilters);

    const showFilters = !!syncedWallets && (!!total || !!filtersCount) && !managerSearchValue;

    const removeQueryFilters = (category: string, value?: string) => {
        if (!managerFilters) return;

        if (category === 'floorPrice') {
            dispatch(
                updateNFTManagerFilters({
                    filter: {
                        floorPriceCurrency: undefined,
                        floorPriceGe: undefined,
                        floorPriceLe: undefined,
                    },
                }),
            );
        } else {
            const removed = managerFilters[category].filter((item) => item !== value);

            dispatch(
                updateNFTManagerFilters({
                    filter: { [category]: removed },
                }),
            );
        }
    };
    const onUpdateSearchValue = (value: string) => {
        dispatch(setNFTManagerSearchValue(value));
    };

    const filterListMarkup = <FiltersListAccordion />;

    return {
        showFilters,
        filtersCount,
        searchValue: managerSearchValue,
        currentFilters: managerFilters,
        onClearFilters,
        onUpdateSearchValue,
        onRemoveFilter: removeQueryFilters,
        filterListMarkup,
    };
};
